/**
 * /erp/settings index — redirect to the first sub-page so the gear
 * doesn't drop the user onto an empty Outlet.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/erp/settings/")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/warehouses" });
  },
});
